// extracted by mini-css-extract-plugin
module.exports = {"container":"lightContainer_container__1fM2f","titleView":"lightContainer_titleView__m28Nj","title":"lightContainer_title__2KDga","body":"lightContainer_body__3Bb28"};